<template>
  <div class="c-filter">
    <div class="c-form">
      <el-form class="query-form elementui-common-form-styles" v-highlight label-width="50" inline>
        <el-form-item>
          <el-input
            v-model="queryForm.keyword"
            @keyup.enter.native="search"
            style="width: 240px"
            placeholder="账号名称/账号ID/计划主ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="媒体">
          <el-select
            v-model="queryForm.mediaId"
            :popper-append-to-body="false"
            clearable
            collapse-tags
            filterable
            placeholder="全部"
            style="width: 120px"
          >
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="管理人">
          <el-select
            v-model="queryForm.opId"
            :popper-append-to-body="false"
            clearable
            collapse-tags
            filterable
            placeholder="全部"
            style="width: 120px"
          >
            <el-option v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="账号状态">
          <el-select
            v-model="queryForm.status"
            :popper-append-to-body="false"
            collapse-tags
            filterable
            placeholder="全部"
            style="width: 120px"
          >
            <el-option
              v-for="item in [
                { name: '启用', id: 1 },
                { name: '禁用', id: 0 }
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="同步状态">
          <el-select
            v-model="queryForm.synStatus"
            :popper-append-to-body="false"
            collapse-tags
            clearable
            placeholder="全部"
            style="width: 120px"
          >
            <el-option
              v-for="item in [
                { name: '同步中', id: 1 },
                { name: '同步成功', id: 2 },
                { name: '同步失败', id: 3 }
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据月份">
          <el-date-picker
            style="width: 90px"
            placeholder="选择数据月份"
            v-model="queryForm.beginTime"
            value-format="yyyy-MM-01"
            type="month"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="开户主体">
          <el-select v-model="queryForm.companyId" filterable clearable placeholder="全部" style="width: 120px">
            <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <ElFormItem label="数据关联模式" label-width="50">
          <el-select v-model="queryForm.dataModel" clearable collapse-tags filterable placeholder="全部">
            <el-option v-for="item in dataModelData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <el-form-item class="bg-transparent">
          <el-button type="primary" :loading="loading" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { initPageData, MEDIAS, PTOM_USERS } from '@/data/global-opts'
import moment from 'moment'
import { queryCompanyList } from '@/api/sysmana.model'
import { dataModelData } from '@/views/sysmana/tasksyc/const.js'

const PAGE_REQUIRED_OPTS = initPageData([MEDIAS, PTOM_USERS])
export default {
  name: 'reconciliationFilter',
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    search() {
      this.$emit('search', { ...this.queryForm })
    }
  },
  data() {
    return {
      companyList: [],
      dataModelData,
      queryForm: {
        keyword: '',
        mediaId: '',
        opId: '',
        status: 1,
        beginTime: '',
        synStatus: '',
        companyId: '',
        dataModel: ''
      }
    }
  },
  created() {
    queryCompanyList().then((data) => {
      this.companyList = data || []
    })
    this.queryForm.beginTime = moment().subtract(1, 'month').format('YYYY-MM-01')
    // this.queryForm.opId = parseInt(Cookies.get('ch_op_id'))
    this.search()
  }
}
</script>
